document.addEventListener('DOMContentLoaded', function() {
    const existingPopup = document.getElementById('deletepopup');
    if (existingPopup) {
        if (existingPopup.parentElement !== document.body) {
            document.body.appendChild(existingPopup);
        }
    } else {
        createDeletePopup();
    }
    
    function createDeletePopup() {
        const popup = document.createElement('div');
        popup.id = 'deletepopup';
        popup.className = 'hp-hidden';
        popup.innerHTML = `
            <div class="deletepopup-overlay hp-fixed hp-top-0 hp-left-0 hp-w-full hp-h-full hp-bg-black hp-bg-opacity-50 hp-flex hp-items-center hp-justify-center">
                <div class="deletepopup-content hp-bg-white hp-flex hp-flex-col hp-gap-5 hp-py-10 hp-px-10 hp-items-center hp-justify-center hp-rounded-lg hp-p-4 hp-w-full hp-max-w-md hp-relative hp-z-[10000]">
                    <div id="closePopup" class="hp-cursor-pointer hp-w-full hp-flex hp-justify-end" onclick="document.getElementById('deletepopup').classList.add('hp-hidden')">
                        <svg xmlns="http://www.w3.org/2000/svg" class="hp-w-10 hp-text-dgray" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                    </div>
                    <div class="hp-mb-2">
                        <svg fill="#000" height="36px" width="36px" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 315 315" xmlns:xlink="http://www.w3.org/1999/xlink" enable-background="new 0 0 315 315"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="m256.774,23.942h-64.836v-6.465c0-9.636-7.744-17.477-17.263-17.477h-34.348c-9.521,0-17.266,7.841-17.266,17.478v6.465h-64.835c-9.619,0-17.445,7.76-17.445,17.297v11.429c0,7.168 4.42,13.33 10.698,15.951 1.989,39.623 13.5,231.193 14.018,239.801 0.222,3.696 3.284,6.58 6.987,6.58h170.033c3.703,0 6.766-2.884 6.987-6.58 0.518-8.607 12.028-200.178 14.018-239.801 6.278-2.621 10.698-8.783 10.698-15.951v-11.43c5.68434e-14-9.537-7.826-17.297-17.446-17.297zm-119.713-6.464c0-1.918 1.465-3.478 3.266-3.478h34.348c1.8,0 3.264,1.56 3.264,3.478v6.465h-40.877v-6.465zm-82.282,23.761c0-1.818 1.546-3.297 3.445-3.297h198.549c1.899,0 3.445,1.478 3.445,3.297v11.429c0,1.819-1.546,3.299-3.445,3.299h-198.548c-1.899,0-3.445-1.479-3.445-3.299v-11.429zm181.143,259.761h-156.848c-2.055-34.247-11.479-191.674-13.51-231.033h183.867c-2.031,39.359-11.454,196.786-13.509,231.033z"></path> <path d="m157.5,95.125c-3.866,0-7,3.134-7,7v176.109c0,3.866 3.134,7 7,7 3.866,0 7-3.134 7-7v-176.109c0-3.866-3.134-7-7-7z"></path> <path d="m110.2,102.04c-0.202-3.86-3.507-6.837-7.355-6.625-3.86,0.201-6.827,3.494-6.625,7.355l9.182,175.829c0.195,3.736 3.285,6.635 6.984,6.635 0.123,0 0.247-0.003 0.371-0.01 3.86-0.201 6.827-3.494 6.625-7.355l-9.182-175.829z"></path> <path d="m212.155,95.415c-3.899-0.223-7.153,2.764-7.355,6.625l-9.184,175.829c-0.202,3.861 2.765,7.154 6.625,7.355 0.125,0.007 0.248,0.01 0.371,0.01 3.698,0 6.789-2.898 6.984-6.635l9.184-175.829c0.202-3.861-2.764-7.154-6.625-7.355z"></path> </g> </g></svg>
                    </div>
                    <div class="hp-text-center hp-text-base hp-font-bold hp-text-dgray">Bu ürünü favorilerize eklemek ister misiniz?</div>
                    <div class="hp-flex hp-flex-row hp-gap-2 hp-w-full">
                        <button 
                            onclick="deleteOnly()" 
                            class="hp-bg-white hp-text-black hp-font-bold hp-w-full hp-h-[50px] hp-rounded-[3px] hp-flex hp-items-center hp-justify-center hover:hp-bg-black hover:hp-text-white hp-border hp-border-solid hp-border-black hp-transition-all hp-duration-200">
                            Sil
                        </button>
                        <div
                            id="addToFavoritesButton"
                            class="holly-wishlist-remove-from-cart hp-text-white hp-bg-black hp-font-bold hp-w-full hp-h-[50px] hp-rounded-[3px] hp-flex hp-items-center hp-justify-center hover:hp-bg-white hover:hp-text-black hp-border hp-border-solid hp-border-black hp-transition-all hp-duration-200"
                            onclick="hollyRemoveProductFromCart(this)">
                            <svg
                                  class="delete-icon"
                                  width="16"
                                  height="16"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  style="display:none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g clip-path="url(#clip0_89_138798)">
                                      <path stroke="currentColor" stroke-width="2" d="M16.5902 4C17.7115 3.99982 18.8289 4.45165 19.6828 5.34108C20.5645 6.26011 21 7.46571 21 8.66859C21 9.87132 20.5646 11.0766 19.683 11.995L18.9178 12.792L11.9999 20L5.08208 12.7931L4.31723 11.9964C3.43545 11.0774 3 9.87177 3 8.66889C3 7.46616 3.43536 6.26092 4.31704 5.3425C5.17107 4.4529 6.28848 4.00107 7.40971 4.00107C8.53095 4.00107 9.64836 4.4529 10.5024 5.34251L12 6.90246L13.4978 5.3423C14.3518 4.45228 15.469 4.00018 16.5902 4Z"></path>
                                  </g>
                                  <defs>
                                      <clipPath id="clip0_89_138798">
                                          <rect width="24" height="24" fill="white"></rect>
                                      </clipPath>
                                  </defs>
                                </svg>
                                <svg style="margin-left:10px" class="loading-icon hp-hidden" width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 2V6M12 18V22M6 12H2M22 12H18M19.07 4.93L16.24 7.76M7.76 16.24L4.93 19.07M19.07 19.07L16.24 16.24M7.76 7.76L4.93 4.93" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                            <p class="!hp-text-base !hp-font-bold hp-w-full hp-text-center">Sil ve Favoriye Ekle</p>
                        </div>
                    </div>
                </div>
            </div>
        `;
        document.body.appendChild(popup);
        return popup;
    }
    
    window.deleteOnly = async function() {
      try {
        const deletePopup = document.getElementById('deletepopup');
        const itemKey = deletePopup.getAttribute('data-item-key');
        
        
        if (!itemKey) {
          return;
        }
  
        let response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: itemKey,
            quantity: 0
          })
        });
  
        if (response.ok) {
          let cart = await response.json();
  
          document.dispatchEvent(new CustomEvent('on:cart:change', {
            detail: cart
          }));
  
          deletePopup.classList.add('hp-hidden');
        } else {
          
        }
      } catch (error) {
       
      }
    };


    document.addEventListener("click", function (event) {
      const deleteBtn = event.target.closest('button[onclick="deleteOnly()"]');
      if (!deleteBtn) return;
    
      const itemKey = document.getElementById('deletepopup')?.getAttribute('data-item-key');
      if (!itemKey) return;
    
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          const matchedItem = cart.items.find(i => i.key === itemKey);
          if (matchedItem && matchedItem.product_id) {
            personaclick("track", "remove_from_cart", matchedItem.product_id.toString());
          }

          fetch('/cart.js')
          .then(res => res.json())
          .then(updatedCart => {
            const updateData = updatedCart.items.map(item => ({
              id: item.product_id.toString(),
              amount: item.quantity
            }));
            personaclick("track", "cart", updateData);
          });

        })
        .catch(err => console.warn("remove_from_cart tracking (deleteOnly) error:", err));
    });

    document.addEventListener('click', function (event) {
          // Check if the clicked element is the holly-wishlist-remove-from-cart button
          const button = event.target.closest('.holly-wishlist-remove-from-cart');
          if (button) {
            // Prevent duplicate handling if the onclick attribute already manages favorites
            if (button.hasAttribute('data-handled')) {
              return;
            }
        
            // Mark the button as handled to avoid duplicate logic
            button.setAttribute('data-handled', 'true');
        
            // Handle the cart removal logic
            const itemKey = button.getAttribute('data-line_item_key');
            if (itemKey) {
              removeItemFromCart(itemKey);
            }
          }
        });

      async function removeItemFromCart(itemKey) {
          try {
            const response = await fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                id: itemKey,
                quantity: 0,
              }),
            });
        
            if (response.ok) {
              const cart = await response.json();

                personaclick("track", "remove_from_cart", cart.items_removed[0].product_id);
                personaclick("track", "wish", cart.items_removed[0].product_id);

                const updateData = cart.items.map(item => ({
                  id: item.product_id.toString(),
                  amount: item.quantity
                }));
                personaclick("track", "cart", updateData);
        
              // Dispatch a custom event to update the cart UI
              document.dispatchEvent(
                new CustomEvent('on:cart:change', {
                  detail: cart,
                })
              );
            } else {
              console.error('Failed to remove item from cart:', await response.text());
            }
          } catch (error) {
            console.error('Error removing item from cart:', error);
          }
        }
  
    function setupQuickDeleteButtons() {
      const deleteButtons = document.querySelectorAll('.cart-item-delete-button, .holly-wishlist-remove-from-cart');
      
      deleteButtons.forEach((button) => {
        button.removeEventListener('click', handleQuickDelete);
        button.addEventListener('click', handleQuickDelete);
      });
    }
  
    async function handleQuickDelete(event) {
      event.preventDefault();
      const button = this;
      
      const deleteIcon = button.querySelector('.delete-icon');
      const loadingIcon = button.querySelector('.loading-icon');
      
      deleteIcon.classList.add('hp-hidden');
      loadingIcon.classList.remove('hp-hidden');
      button.disabled = true;
      
      const itemKey = button.getAttribute('data-item-key');
      
      try {
        let response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: itemKey,
            quantity: 0
          })
        });
  
        if (response.ok) {
          let cart = await response.json();
          
          document.dispatchEvent(new CustomEvent('on:cart:change', {
            detail: cart
          }));
        } else {
          console.error('Failed to delete item via quick delete:', await response.text());
          deleteIcon.classList.remove('hp-hidden');
          loadingIcon.classList.add('hp-hidden');
          button.disabled = false;
        }
      } catch (error) {
        console.error('Error in handleQuickDelete:', error);
        deleteIcon.classList.remove('hp-hidden');
        loadingIcon.classList.add('hp-hidden');
        button.disabled = false;
      }
    }
    
    function ensureSinglePopup() {
      const allPopups = document.querySelectorAll('#deletepopup');
      
      if (allPopups.length === 0) {
        return createDeletePopup();
      }
      
      const firstPopup = allPopups[0];
      if (firstPopup.parentElement !== document.body) {
        document.body.appendChild(firstPopup);
      }
      
      for (let i = 1; i < allPopups.length; i++) {
        allPopups[i].remove();
      }
      
      return firstPopup;
    }
  
    function checkAndBindPopupEvents() {
      
      setupQuickDeleteButtons();
      
      const trashButtons = document.querySelectorAll('.quantity-down');
      
      trashButtons.forEach((button) => {
        button.removeEventListener('click', handleTrashClick); 
        button.addEventListener('click', handleTrashClick); 
      });
    }
  
    function handleTrashClick(event) {
      const quantityInput = this.parentNode.querySelector('.cart-item__quantity-input');
      
      if (quantityInput && parseInt(quantityInput.value, 10) === 1) {
        event.preventDefault();
  
        const itemKey = this.getAttribute('data-trash-button');
        
        const deletePopup = ensureSinglePopup();
        
        if (deletePopup) {
          deletePopup.setAttribute('data-item-key', itemKey);
          
          const favButton = deletePopup.querySelector('#addToFavoritesButton');
          if (favButton && itemKey) {
            const cartItem = document.querySelector(`[data-line_item_key="${itemKey}"]`);
            if (cartItem) {
              const dataAttrs = ['product_id', 'variant_id', 'line_item_key', 'product_price', 'line-'];
              dataAttrs.forEach(attr => {
                const value = cartItem.getAttribute(`data-${attr}`);
                if (value) {
                  favButton.setAttribute(`data-${attr}`, value);
                }
              });
              favButton.setAttribute('data-cart_item', 'true');
              favButton.setAttribute('data-favorite', 'false');
            }
          }
        }
  
        document.dispatchEvent(new CustomEvent("triggerDeletePopup"));
      }
    }

    document.addEventListener('click', function (event) {
      const button = event.target.closest('.holly-wishlist-remove-from-cart');
      if (button) {
        // Get the item key from the popup
        const deletePopup = document.getElementById('deletepopup');
        const itemKey = deletePopup.getAttribute('data-item-key');
    
        if (!itemKey) {
          console.error('No item key found for holly-wishlist-remove-from-cart');
          return;
        }
    
        // Call deleteOnly to remove the item from the cart
        deleteOnly();
    
        // Optionally, handle additional wishlist logic here
      }
    });
    
    // Yeni bir ürün eklenince veya drawer açıldığında gereken event listener'ları eklemek için mutation observer kullan
    const setupMutationObserver = () => {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            // DOM'a yeni eklenen elementler var
            for (let i = 0; i < mutation.addedNodes.length; i++) {
              const node = mutation.addedNodes[i];
              
              // Node bir element mi ve cart-item içeriyor mu?
              if (node.nodeType === 1 && (
                  node.classList && node.classList.contains('cart-item') || 
                  node.querySelector && node.querySelector('.cart-item')
                )) {
                checkAndBindPopupEvents();
                break;
              }
              
              // Drawer veya cart container eklendi mi?
              if (node.nodeType === 1 && (
                  node.id === 'side-cart' || 
                  node.classList && node.classList.contains('cart-container') ||
                  node.querySelector && (
                    node.querySelector('#side-cart') || 
                    node.querySelector('.cart-container')
                  )
                )) {
                setTimeout(() => {
                  checkAndBindPopupEvents();
                }, 300);
                break;
              }
            }
          }
        });
      });
      
      observer.observe(document.body, { 
        childList: true, 
        subtree: true 
      });
      
      return observer;
    };
    
    document.addEventListener('drawer-opened', function(event) {
      if (event.detail && event.detail.id === 'side-cart') {
        setTimeout(() => {
          checkAndBindPopupEvents();
        }, 300);
      }
    });
    
    ensureSinglePopup();
    checkAndBindPopupEvents();
    
    const observer = setupMutationObserver();
    
    const cartEvents = ['cart:update', 'cart:refresh', 'on:cart:change', 'cart:added'];
    cartEvents.forEach(eventName => {
      document.addEventListener(eventName, function(event) {
        setTimeout(() => {
          ensureSinglePopup();
          checkAndBindPopupEvents();
        }, 300);
      });
    });
  
    document.addEventListener('click', function(event) {
      const clickedElement = event.target;
      const quantityDownButton = clickedElement.closest('.quantity-down');
      
      if (quantityDownButton) {
        
        if (!quantityDownButton._hasTrashClickHandler) {
          quantityDownButton.addEventListener('click', handleTrashClick);
          quantityDownButton._hasTrashClickHandler = true;
          
          const quantityInput = quantityDownButton.parentNode.querySelector('.cart-item__quantity-input');
          if (quantityInput && parseInt(quantityInput.value, 10) === 1) {
            const fakeEvent = { preventDefault: () => {} };
            handleTrashClick.call(quantityDownButton, fakeEvent);
          }
        }
      }
    }, true); // Use capture phase to get events before they reach the normal target
  
    document.addEventListener("triggerDeletePopup", function () {
      const deletePopup = ensureSinglePopup();
      
      if (deletePopup) {
        deletePopup.classList.remove('hp-hidden');
      }
    });
    
});